/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { PostApiBarberShiftIdAppointmentsAccept200, PostApiBarberShiftIdAppointmentsAccept400, PostApiBarberShiftIdAppointmentsAccept401, PostApiBarberShiftIdAppointmentsAccept403, PostApiBarberShiftIdAppointmentsAccept404, PostApiBarberShiftIdAppointmentsAccept500, PostApiBarberShiftIdAppointmentsAcceptMutationResponse, PostApiBarberShiftIdAppointmentsAcceptPathParams } from "../entities/PostApiBarberShiftIdAppointmentsAccept";
import { modelsErrorResponseSchema } from "./models/errorResponseSchema";
import { z } from "zod/v4";

export const postApiBarberShiftIdAppointmentsAcceptPathParamsSchema = z.object({
    "id": z.coerce.number().int().describe("ID смены")
    }) as unknown as z.ZodType<PostApiBarberShiftIdAppointmentsAcceptPathParams>

/**
 * @description OK
 */
export const postApiBarberShiftIdAppointmentsAccept200Schema = z.object({
    
    }).catchall(z.string()) as unknown as z.ZodType<PostApiBarberShiftIdAppointmentsAccept200>

/**
 * @description Bad Request
 */
export const postApiBarberShiftIdAppointmentsAccept400Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftIdAppointmentsAccept400>

/**
 * @description Unauthorized
 */
export const postApiBarberShiftIdAppointmentsAccept401Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftIdAppointmentsAccept401>

/**
 * @description Forbidden
 */
export const postApiBarberShiftIdAppointmentsAccept403Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftIdAppointmentsAccept403>

/**
 * @description Not Found
 */
export const postApiBarberShiftIdAppointmentsAccept404Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftIdAppointmentsAccept404>

/**
 * @description Internal Server Error
 */
export const postApiBarberShiftIdAppointmentsAccept500Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftIdAppointmentsAccept500>

export const postApiBarberShiftIdAppointmentsAcceptMutationResponseSchema = z.lazy(() => postApiBarberShiftIdAppointmentsAccept200Schema) as unknown as z.ZodType<PostApiBarberShiftIdAppointmentsAcceptMutationResponse>